import { END_POINTS } from "../helpers";
import { CommonBody, Partner, Subscription_List } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};
export type Subscription = {
  planName: string;
  planAmount: number;
  planDuration: number;
  mileageLimit: number;
  allowedLocations: string;
  vehicleCategory: string;
  paymentMethod: number;
  additionalBenefits: string;
};

export const subscriptionApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSubscription: builder.query<
      CommonResponse & { data: Subscription_List },
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.subscription}?page=${page}&searchText=${search}`,
        method: "GET",
      }),
    }),
    addSubscription: builder.mutation<
      CommonResponse & { data: Subscription },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.subscription,
        method: "POST",
        body,
      }),
    }),

    updateSubscription: builder.mutation<
      CommonResponse & { data: Subscription },
      { body: CommonBody; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.subscription}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    subscriptionDetails: builder.query<
      CommonResponse & { data: Subscription },
      { id: string | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subscription}/${id}`,
        method: "GET",
      }),
    }),

    deleteSubscription: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.subscription}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllSubscriptionQuery,
  useLazySubscriptionDetailsQuery,
  useAddSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useLazyDeleteSubscriptionQuery,
} = subscriptionApi;
